import { render } from "./Evaluation4.vue?vue&type=template&id=87682d32"
import script from "./Evaluation4.vue?vue&type=script&lang=js"
export * from "./Evaluation4.vue?vue&type=script&lang=js"
script.render = render

export default script